import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { actionCreators } from "../../state"
import { euroQtyFormat, euroFormat, quantityFormat } from "../../utils"
import { DexxMaxButton } from "../light/LightButton"
import Popup from "../Popup"
import { DexxNumericInput, DexxSelectInput } from "../utils/Input"
import { LiquidityPool } from "../../PoolContext";
import GenericPopup from "./GenericPopup"
import PopupRowData from "./utils/PopupRowData"
import PopupLabelAndValue from "./utils/PopupLabelAndValue"
import PopupDivider from "./utils/PopupDivider"

export default function CreateLPPopup(props: { closeFunction: Function, setLiquidityPoolCreationRequest: Function, tokenA: any, lpNum: number }): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    const [lpName, setLpName] = useState<string>("")
    const [issuedTokens, setIssuedTokens] = useState<any>()
    const [balance, setBalance] = useState<any>()

    const tokenAticker = props.tokenA.ticker
    const [tokenB, setTokenB] = useState<string>('XEUR')
    const [amountTokenA, setAmountTokenA] = useState<number>(0.00)
    const [amountTokenB, setAmountTokenB] = useState<number>(0)
    const [calcAmountTokenA, setCalcAmountTokenA] = useState<number>(0)
    const [calcAmountTokenB, setCalcAmountTokenB] = useState<number>(0.00)
    const [spotPrice, setSpotPrice] = useState<number>(0)
    const [maxTokenA, setMaxTokenA] = useState<number>(0)
    const [maxTokenB, setMaxTokenB] = useState<number>(0)
    const [lpShares, setLpShares] = useState<number>(0)
    const [liquidityPoolList, setLiquidityPoolList] = useState<LiquidityPool[]>([])

    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")

    let issuedTokensList = [
        (issuedTokens?.listed_tokens) ?
            issuedTokens.listed_tokens : []]

    useEffect(() => {
        actions.getIssuedTokens(setIssuedTokens)
        //actions.getIssuerBalance(setBalance)
        actions.getActualBalance(setBalance)
        actions.getAllLiquidityPoolRequests(setLiquidityPoolList, {})
    }, [])

    useEffect(() => {
        if (props.lpNum === 0) setLpName("LP_" + tokenAticker + "_" + tokenB)
        else setLpName("LP_" + tokenAticker + "_" + tokenB + "_" + props.lpNum)
    }, [props.lpNum, tokenAticker])

    useEffect(() => {
        if (balance && balance.payment_tokens) {
            setMaxTokenB(balance.payment_tokens.available_total)
        }
        if (balance && balance.balance.security_entries) {
            let tokensFromClass = balance.balance.security_entries.filter((c: any) => { return c.class === props.tokenA.asset_class })
            if (tokensFromClass[0] && tokensFromClass[0].class_balance) {
                let actualToken = tokensFromClass[0].class_balance.filter((t: any) => { return t.token_uuid === props.tokenA.uuid })
                if (actualToken[0] && actualToken[0]?.available_quantity)
                    setMaxTokenA(actualToken[0]?.available_quantity)
            }
        }
    }, [balance, props.tokenA])

    useEffect(() => {
        if (amountTokenB !== 0 && spotPrice !== 0) {
            let sp = parseFloat(spotPrice.toString().replace(",", "."))
            let amountB = parseFloat(amountTokenB.toString().replace(",", "."))
            // if desired_euro_amount > euro_available ==> desired_euro_amount == euro_available (update field in popup)
            if (amountB > maxTokenB) setAmountTokenB(maxTokenB)

            // desired_tokens_amount == ROUNDDOWN( desired_euro_amount / desired_price ; 0 decimals ) //internal, not shown
            let fixedAmountA = sp > 0 ? parseInt(Math.floor(amountB / sp).toFixed(0)) : 0

            // if desired_tokens_amount > tokens_available ==> tokens_amount == tokens_available
            let amount = fixedAmountA < maxTokenA ? fixedAmountA : maxTokenA
            setAmountTokenA(amount)

            setCalcAmountTokenA((amount))

            // euro_amount == ROUND( tokens_amount * desired_price ; 2 decimals) //it's the same for both cases
            setCalcAmountTokenB(Math.floor((amount * sp * 100)) / 100)

            //setAmountTokenB(Math.round((amount * spotPrice * 100))/100)
        } else if (amountTokenB === 0 || spotPrice === 0) {
            setCalcAmountTokenA((0))
            setCalcAmountTokenB(0)
        }
    }, [maxTokenA, amountTokenB, spotPrice, maxTokenB])

    function handleMax() {
        if (spotPrice !== 0) {
            let sp = parseFloat(spotPrice.toString().replace(",", "."))
            //When MAX is pressed, the calculation needs to take the min of both ways:

            // desired_euro_amount = ROUNDUP( tokens_available * desired_price ; 2 decimals )
            let fixedAmountB = Math.round(maxTokenA * sp * 100) / 100

            // if desired_euro_amount > euro_available ==> desired_euro_amount == euro_available
            if (fixedAmountB > maxTokenB) fixedAmountB = maxTokenB

            // update field desired_euro_amount
            setAmountTokenB(fixedAmountB)

            // tokens_amount == ROUNDDOWN( desired_euro_amount / desired_price ; 0 decimals )
            let fixedAmountA = Math.floor(parseInt((fixedAmountB / sp).toFixed(0)) * 100) / 100

            // update fields in box EFFECTIVE...
            setCalcAmountTokenA((fixedAmountA))
            setCalcAmountTokenB((Math.round((fixedAmountA * sp * 100)) / 100))
        } else {
            setTitlePopUp("Sorry!")
            setMsgPopUp("Please specify the spot price.")
            setShowPopUp(true)
        }
    }

    useEffect(() => {
        if (calcAmountTokenA !== 0 && calcAmountTokenB !== 0) {
            setLpShares(Math.floor((calcAmountTokenA) * (calcAmountTokenB)))
        }
    }, [amountTokenA, amountTokenB, spotPrice])

    function handleSubmit() {
        if (calcAmountTokenA > 0 && calcAmountTokenB > 0 && lpName.length > 0 &&
            tokenAticker.length > 0 && tokenB.length > 0) {

            if (calcAmountTokenB > maxTokenB) {
                setTitlePopUp("Sorry!")
                setMsgPopUp("Insufficient funds available to complete transaction. Please deposit additional funds to your wallet.")
                setShowPopUp(true)

            } else {
                let ta = issuedTokensList.length > 0 ?
                    issuedTokensList[0].filter((t: any) => t.ticker === tokenAticker) : { uuid: "" }
                let request = {
                    lp_name: lpName,
                    token_a_uuid: ta[0].uuid,
                    amount_a: calcAmountTokenA,
                    token_b_uuid: "",
                    amount_b: calcAmountTokenB.toString().replace(",", ".")
                }
                actions.createLiquidityPool(request, props.setLiquidityPoolCreationRequest)
            }

        } else {
            setTitlePopUp("Sorry!")
            setMsgPopUp("You missed one or more required fields.")
            setShowPopUp(true)
        }
    }

    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true}
            close={() => { setShowPopUp(false) }} />
        <GenericPopup closeFunction={props.closeFunction} handleSubmit={handleSubmit}>
            <PopupRowData backgroundColor="succ1_lightest">
                <PopupLabelAndValue label="My Balance" />
                <PopupLabelAndValue label={tokenAticker} value={quantityFormat(maxTokenA)} />
                <PopupLabelAndValue label={tokenB} value={euroFormat(maxTokenB)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData>
                <PopupLabelAndValue label={"Asset Name"} value={props.tokenA.asset_name}
                    className="col-span-2" />
                <PopupLabelAndValue label={"Ticker"} value={tokenAticker} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData backgroundColor="succ1_lighter" nColumns="2">
                <PopupLabelAndValue label={"Desired Currency Token"} value={
                    <DexxSelectInput value={tokenB} fun={setTokenB}
                        items={["XEUR"]}
                        className="w-28 text-primary text-sm" />
                } />
                <PopupLabelAndValue label={"Desired Spot Price *"} value={
                    <DexxNumericInput value={spotPrice} className="w-3/4" fun={setSpotPrice}
                        max={maxTokenB} />
                } />
            </PopupRowData>
            <PopupRowData backgroundColor="succ1_lighter" nColumns="2">
                <PopupLabelAndValue label={"Desired " + tokenB + " Amount *"} value={
                    <DexxNumericInput value={amountTokenB} className="text-sm" max={maxTokenB}
                        fun={(v: any) => setAmountTokenB((v ? v : 0))} />
                } />
                <div className="flex items-end">
                    <DexxMaxButton label={"MAX"} className="px-3 rounded-lg mt-1 font-normal"
                        onClick={() => { handleMax() }}
                        color1="primary" color2="primary" />
                </div>
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData nColumns="1">
                <PopupLabelAndValue label={"LP Name"} value={lpName} />
            </PopupRowData>
            <PopupRowData>
                <PopupLabelAndValue label={"Initial Reserves"} value="for LP creation" />
                <PopupLabelAndValue label={tokenAticker} value={euroQtyFormat(calcAmountTokenA)} />
                <PopupLabelAndValue label={tokenB} value={euroFormat(calcAmountTokenB)} />
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData nColumns="1">
                <div className="text-succ1 text-sm font-medium">
                    Review</div>
                <div className="text-primary text-sm font-normal">
                    Effective {tokenAticker}:
                    <strong>{euroQtyFormat(calcAmountTokenA)}</strong>
                </div>
                <div className="text-primary text-sm font-normal">
                    Effective {tokenB}:
                    <strong>{euroFormat(calcAmountTokenB)}</strong>
                </div>
                <div className="text-primary text-sm font-normal mb-2">
                    LP shares to receive:
                    <strong>{euroQtyFormat(lpShares)}</strong>
                </div>
            </PopupRowData>
        </GenericPopup>
    </>
}